/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：199
 */

module.exports = {
  packageEditorContainer: "PackageEditor_packageEditorContainer__20PJk",
  packageContent: "PackageEditor_packageContent__3hAzj",
  leftContent: "PackageEditor_leftContent__1ahGq",
  rightContent: "PackageEditor_rightContent__1rB3m",
  packageItemLabel: "PackageEditor_packageItemLabel__19k4M",
  packageProjectTitle: "PackageEditor_packageProjectTitle__29K9B",
  warningTips: "PackageEditor_warningTips__13MPZ",
  packageIconBox: "PackageEditor_packageIconBox__2PFua",
  packageIcon: "PackageEditor_packageIcon__1wnLA",
  splashImageBox: "PackageEditor_splashImageBox__SAsKa",
  splashImage: "PackageEditor_splashImage__VDsaq",
  signImage: "PackageEditor_signImage__3eOS-",
  cover: "PackageEditor_cover__3ea0G",
  visible: "PackageEditor_visible__1yMy_",
  replaceBtn: "PackageEditor_replaceBtn__1yfNp",
  plateFormTips: "PackageEditor_plateFormTips__3gzgO",
  footer: "PackageEditor_footer__yZ3l8",
  imagePopover: "PackageEditor_imagePopover__sxRzr",
  iconPopover: "PackageEditor_iconPopover__2muXY",
  packageIconWrapper: "PackageEditor_packageIconWrapper__2OneX",
  packageIconItem: "PackageEditor_packageIconItem__9RBnE",
  active: "PackageEditor_active__3WWSC",
  uploadIconBtn: "PackageEditor_uploadIconBtn__2QJYT",
  iconSizeTips: "PackageEditor_iconSizeTips__f95OL",
  splashPopover: "PackageEditor_splashPopover__3w0rG",
  splashTitle: "PackageEditor_splashTitle__2vSAe",
  pageBtnBox: "PackageEditor_pageBtnBox__g4YqU",
  pageBtn: "PackageEditor_pageBtn__1t_uf",
  prev: "PackageEditor_prev__3ulSy",
  next: "PackageEditor_next__358rQ",
  disable: "PackageEditor_disable__3Ns-h",
  packageSplashWrapper: "PackageEditor_packageSplashWrapper__pGzDh"
}
